export default __webpack_public_path__ + "static/media/151-dialogue.eeb320f6.png";